import _defineProperty from "/app/web/node_modules/@babel/runtime/helpers/esm/defineProperty";

var _TASK_TYPE_COLOR, _TASK_TYPE_LETTER;

import { Tag, Tooltip } from 'antd';
import { TaskType } from 'core/modules/tasks/task.interface';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { jsx as _jsx } from "react/jsx-runtime";
var TASK_TYPE_COLOR = (_TASK_TYPE_COLOR = {}, _defineProperty(_TASK_TYPE_COLOR, TaskType.Report, 'cyan'), _defineProperty(_TASK_TYPE_COLOR, TaskType.Homologation, 'volcano'), _defineProperty(_TASK_TYPE_COLOR, TaskType.Recognition, 'gold'), _TASK_TYPE_COLOR);
var TASK_TYPE_LETTER = (_TASK_TYPE_LETTER = {}, _defineProperty(_TASK_TYPE_LETTER, TaskType.Report, 'P'), _defineProperty(_TASK_TYPE_LETTER, TaskType.Homologation, 'H'), _defineProperty(_TASK_TYPE_LETTER, TaskType.Recognition, 'F'), _TASK_TYPE_LETTER);
export var TaskTypeTag = function TaskTypeTag(_ref) {
  var type = _ref.type,
      withTooltip = _ref.withTooltip;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  return useMemo(function () {
    return /*#__PURE__*/_jsx(Tooltip, {
      open: withTooltip ? undefined : false,
      title: t("form.task.type.values.".concat(type)),
      children: /*#__PURE__*/_jsx(Tag, {
        color: TASK_TYPE_COLOR[type],
        children: TASK_TYPE_LETTER[type]
      })
    });
  }, [type]);
};